import { Text, TouchableOpacity } from 'react-native';
import { SafeAreaView } from 'react-native-safe-area-context';
import styled from 'styled-components/native';

export const Container = styled(SafeAreaView)`
  flex: 1;
  background-color: #fff;
`;

export const CloseButton = styled(TouchableOpacity)`
  align-self: flex-end;
  padding: 16px;
`;

export const CloseText = styled(Text)`
  font-size: 18px;
`;
